
// HTTP configuration constants
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

// API endpoints configuration
export const AUTH_ENDPOINTS = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  REFRESH_TOKEN: '/auth/refresh',
  USER_PROFILE: '/profile',
  VERIFY_EMAIL: '/auth/verify-email',
  RESEND_VERIFICATION: '/auth/resend-verification'
} as const;

// Request timeout in milliseconds
export const REQUEST_TIMEOUT = 30000; // 30 seconds

// Max retries for failed requests
export const MAX_RETRIES = 3;

// Default headers
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
} as const;

console.log('🔧 API Configuration loaded:', {
  baseUrl: API_BASE_URL,
  loginEndpoint: AUTH_ENDPOINTS.LOGIN,
  timeout: REQUEST_TIMEOUT,
  maxRetries: MAX_RETRIES
});
